/**
 * Display-only names from the development Odds API NCAA football feed (2026-09).
 * Raw provider names remain the source of truth for matching, quotes, and settlement.
 */
const ncaafSchoolNames: Readonly<Record<string, string>> = {
  "Abilene Christian Wildcats": "Abilene Christian",
  "Air Force Falcons": "Air Force",
  "Alabama Crimson Tide": "Alabama",
  "Alcorn State Braves": "Alcorn State",
  "Appalachian State Mountaineers": "Appalachian State",
  "Arizona State Sun Devils": "Arizona State",
  "Arizona Wildcats": "Arizona",
  "Arkansas Razorbacks": "Arkansas",
  "Arkansas State Red Wolves": "Arkansas State",
  "Army Black Knights": "Army",
  "Auburn Tigers": "Auburn",
  "Austin Peay Governors": "Austin Peay",
  "BYU Cougars": "BYU",
  "Ball State Cardinals": "Ball State",
  "Baylor Bears": "Baylor",
  "Boise State Broncos": "Boise State",
  "Boston College Eagles": "Boston College",
  "Bowling Green Falcons": "Bowling Green",
  "Buffalo Bulls": "Buffalo",
  "Bryant Bulldogs": "Bryant",
  "Cal Poly Mustangs": "Cal Poly",
  "California Golden Bears": "California",
  "Central Michigan Chippewas": "Central Michigan",
  "Charleston Southern Buccaneers": "Charleston Southern",
  "Charlotte 49ers": "Charlotte",
  "Cincinnati Bearcats": "Cincinnati",
  "Citadel Bulldogs": "Citadel",
  "Clemson Tigers": "Clemson",
  "Coastal Carolina Chanticleers": "Coastal Carolina",
  "Colorado Buffaloes": "Colorado",
  "Colorado State Rams": "Colorado State",
  "Delaware Blue Hens": "Delaware",
  "Duke Blue Devils": "Duke",
  "Duquesne Dukes": "Duquesne",
  "East Carolina Pirates": "East Carolina",
  "East Tennessee State Buccaneers": "East Tennessee State",
  "Eastern Illinois Panthers": "Eastern Illinois",
  "Eastern Kentucky Colonels": "Eastern Kentucky",
  "Eastern Michigan Eagles": "Eastern Michigan",
  "Florida A&M Rattlers": "Florida A&M",
  "Florida Atlantic Owls": "Florida Atlantic",
  "Florida Gators": "Florida",
  "Florida International Panthers": "Florida International",
  "Florida State Seminoles": "Florida State",
  "Fordham Rams": "Fordham",
  "Fresno State Bulldogs": "Fresno State",
  "Furman Paladins": "Furman",
  "Georgia Bulldogs": "Georgia",
  "Georgia Southern Eagles": "Georgia Southern",
  "Georgia State Panthers": "Georgia State",
  "Georgia Tech Yellow Jackets": "Georgia Tech",
  "Hampton Pirates": "Hampton",
  "Hawaii Rainbow Warriors": "Hawaii",
  "Houston Baptist Huskies": "Houston Baptist",
  "Houston Cougars": "Houston",
  "Idaho State Bengals": "Idaho State",
  "Illinois Fighting Illini": "Illinois",
  "Indiana Hoosiers": "Indiana",
  "Indiana State Sycamores": "Indiana State",
  "Iowa Hawkeyes": "Iowa",
  "Iowa State Cyclones": "Iowa State",
  "Jacksonville State Gamecocks": "Jacksonville State",
  "James Madison Dukes": "James Madison",
  "Kansas Jayhawks": "Kansas",
  "Kansas State Wildcats": "Kansas State",
  "Kennesaw State Owls": "Kennesaw State",
  "Kent State Golden Flashes": "Kent State",
  "Kentucky Wildcats": "Kentucky",
  "LIU Sharks": "LIU",
  "LSU Tigers": "LSU",
  "Lafayette Leopards": "Lafayette",
  "Lamar Cardinals": "Lamar",
  "Liberty Flames": "Liberty",
  "Louisiana Ragin Cajuns": "Louisiana",
  "Louisiana Tech Bulldogs": "Louisiana Tech",
  "Louisville Cardinals": "Louisville",
  "Maine Black Bears": "Maine",
  "Marshall Thundering Herd": "Marshall",
  "Maryland Terrapins": "Maryland",
  "Memphis Tigers": "Memphis",
  "Mercyhurst Lakers": "Mercyhurst",
  "Miami (OH) RedHawks": "Miami (OH)",
  "Miami Hurricanes": "Miami",
  "Michigan State Spartans": "Michigan State",
  "Michigan Wolverines": "Michigan",
  "Middle Tennessee Blue Raiders": "Middle Tennessee",
  "Minnesota Golden Gophers": "Minnesota",
  "Mississippi State Bulldogs": "Mississippi State",
  "Mississippi Valley State Delta Devils": "Mississippi Valley State",
  "Missouri State Bears": "Missouri State",
  "Missouri Tigers": "Missouri",
  "Morgan State Bears": "Morgan State",
  "Murray State Racers": "Murray State",
  "NC State Wolfpack": "NC State",
  "Navy Midshipmen": "Navy",
  "Nebraska Cornhuskers": "Nebraska",
  "Nevada Wolf Pack": "Nevada",
  "New Hampshire Wildcats": "New Hampshire",
  "New Mexico Lobos": "New Mexico",
  "New Mexico State Aggies": "New Mexico State",
  "Nicholls State Colonels": "Nicholls State",
  "Norfolk State Spartans": "Norfolk State",
  "North Alabama Lions": "North Alabama",
  "North Carolina A&T Aggies": "North Carolina A&T",
  "North Carolina Tar Heels": "North Carolina",
  "North Dakota State Bison": "North Dakota State",
  "North Texas Mean Green": "North Texas",
  "Northern Arizona Lumberjacks": "Northern Arizona",
  "Northern Illinois Huskies": "Northern Illinois",
  "Northwestern State Demons": "Northwestern State",
  "Northwestern Wildcats": "Northwestern",
  "Notre Dame Fighting Irish": "Notre Dame",
  "Ohio Bobcats": "Ohio",
  "Ohio State Buckeyes": "Ohio State",
  "Oklahoma Sooners": "Oklahoma",
  "Oklahoma State Cowboys": "Oklahoma State",
  "Old Dominion Monarchs": "Old Dominion",
  "Ole Miss Rebels": "Ole Miss",
  "Oregon Ducks": "Oregon",
  "Oregon State Beavers": "Oregon State",
  "Penn State Nittany Lions": "Penn State",
  "Pittsburgh Panthers": "Pittsburgh",
  "Portland State Vikings": "Portland State",
  "Purdue Boilermakers": "Purdue",
  "Rhode Island Rams": "Rhode Island",
  "Rice Owls": "Rice",
  "Richmond Spiders": "Richmond",
  "Rutgers Scarlet Knights": "Rutgers",
  "SMU Mustangs": "SMU",
  "Sacramento State Hornets": "Sacramento State",
  "Sam Houston State Bearkats": "Sam Houston State",
  "San Diego State Aztecs": "San Diego State",
  "San Jose State Spartans": "San Jose State",
  "South Alabama Jaguars": "South Alabama",
  "South Carolina Gamecocks": "South Carolina",
  "South Dakota State Jackrabbits": "South Dakota State",
  "South Florida Bulls": "South Florida",
  "Southeast Missouri State Redhawks": "Southeast Missouri State",
  "Southeastern Louisiana Lions": "Southeastern Louisiana",
  "Southern Mississippi Golden Eagles": "Southern Mississippi",
  "Stanford Cardinal": "Stanford",
  "Syracuse Orange": "Syracuse",
  "Tarleton State Texans": "Tarleton State",
  "Temple Owls": "Temple",
  "Tennessee State Tigers": "Tennessee State",
  "Tennessee Volunteers": "Tennessee",
  "Texas A&M Aggies": "Texas A&M",
  "Texas Longhorns": "Texas",
  "Texas State Bobcats": "Texas State",
  "Texas Tech Red Raiders": "Texas Tech",
  "Toledo Rockets": "Toledo",
  "Towson Tigers": "Towson",
  "Troy Trojans": "Troy",
  "Tulane Green Wave": "Tulane",
  "Tulsa Golden Hurricane": "Tulsa",
  "UAB Blazers": "UAB",
  "UCLA Bruins": "UCLA",
  "UConn Huskies": "UConn",
  "UL Monroe Warhawks": "UL Monroe",
  "UMass Minutemen": "UMass",
  "UNLV Rebels": "UNLV",
  "USC Trojans": "USC",
  "UT Rio Grande Valley Vaqueros": "UT Rio Grande Valley",
  "UTEP Miners": "UTEP",
  "UTSA Roadrunners": "UTSA",
  "Utah State Aggies": "Utah State",
  "Utah Tech Trailblazers": "Utah Tech",
  "Utah Utes": "Utah",
  "VMI Keydets": "VMI",
  "Vanderbilt Commodores": "Vanderbilt",
  "Villanova Wildcats": "Villanova",
  "Virginia Cavaliers": "Virginia",
  "Virginia Tech Hokies": "Virginia Tech",
  "Wake Forest Demon Deacons": "Wake Forest",
  "Washington Huskies": "Washington",
  "Washington State Cougars": "Washington State",
  "West Georgia Wolves": "West Georgia",
  "West Virginia Mountaineers": "West Virginia",
  "Western Kentucky Hilltoppers": "Western Kentucky",
  "Western Michigan Broncos": "Western Michigan",
  "Wisconsin Badgers": "Wisconsin",
  "Wyoming Cowboys": "Wyoming",
  "Youngstown St Penguins": "Youngstown St"
};

/** NFL locations, with distinct abbreviations for the shared New York and Los Angeles markets. */
const nflLocationNames: Readonly<Record<string, string>> = {
  "Arizona Cardinals": "Arizona",
  "Atlanta Falcons": "Atlanta",
  "Baltimore Ravens": "Baltimore",
  "Buffalo Bills": "Buffalo",
  "Carolina Panthers": "Carolina",
  "Chicago Bears": "Chicago",
  "Cincinnati Bengals": "Cincinnati",
  "Cleveland Browns": "Cleveland",
  "Dallas Cowboys": "Dallas",
  "Denver Broncos": "Denver",
  "Detroit Lions": "Detroit",
  "Green Bay Packers": "Green Bay",
  "Houston Texans": "Houston",
  "Indianapolis Colts": "Indianapolis",
  "Jacksonville Jaguars": "Jacksonville",
  "Kansas City Chiefs": "Kansas City",
  "Las Vegas Raiders": "Las Vegas",
  "Los Angeles Chargers": "LAC",
  "Los Angeles Rams": "LAR",
  "Miami Dolphins": "Miami",
  "Minnesota Vikings": "Minnesota",
  "New England Patriots": "New England",
  "New Orleans Saints": "New Orleans",
  "New York Giants": "NYG",
  "New York Jets": "NYJ",
  "Philadelphia Eagles": "Philadelphia",
  "Pittsburgh Steelers": "Pittsburgh",
  "San Francisco 49ers": "San Francisco",
  "Seattle Seahawks": "Seattle",
  "Tampa Bay Buccaneers": "Tampa Bay",
  "Tennessee Titans": "Tennessee",
  "Washington Commanders": "Washington"
};

/** Uses concise team names only at the presentation boundary. */
export const displayTeamName = (league: string, name: string): string => {
  if (league === "nfl") return nflLocationNames[name] ?? name;
  return league === "ncaaf" ? ncaafSchoolNames[name] ?? name : name;
};
